<template>
  <app-content class="h-panel">
    <div class="h-panel-bar"><span class="h-panel-title">智能开票</span></div>
    <div class="h-panel-body" style="padding: 40px 20px;">
      <div class="external-tip">
        <i class="h-icon-info external-tip-icon"></i>
        <div class="external-tip-title">智能开票</div>
        <div class="external-tip-desc">{{ cloudMessage }}</div>
        <div class="margin-top">
          <Button color="primary" icon="fa fa-plus" @click="$router.push({name: 'OutputInvoice'})">手工新增销项发票</Button>
        </div>
      </div>
    </div>
  </app-content>
</template>

<script>
export default {
  name: 'IntelligentInvoicing',
  data() {
    return {
      cloudMessage: '智能开票需对接电子税局开放平台与税控/CA 设备，开源版本未接入。请使用手工录入。'
    }
  },
  mounted() {
    this.$api.tax.cloud.status().then(({data}) => {
      if (data && data.message) {
        this.cloudMessage = data.enabled && data.provider ? `${data.message}（服务商：${data.provider}）` : data.message;
      }
    }).catch(() => {
    });
  }
}
</script>

<style lang="less" scoped>
.external-tip {
  margin: 40px auto;
  max-width: 640px;
  text-align: center;
  padding: 40px 30px;
  border: 1px solid #e8e8e8;
  border-radius: 6px;
  background: #fafafa;
}

.external-tip-icon {
  font-size: 48px;
  color: #2db7f5;
}

.external-tip-title {
  font-size: 18px;
  font-weight: bold;
  margin: 16px 0 10px;
}

.external-tip-desc {
  color: #808695;
  font-size: 14px;
  line-height: 22px;
}
</style>
